// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file realtime_event/realtime_event_responses.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { BooleanResponse } from '../common/common_responses_pb';
import { file_common_common_responses } from '../common/common_responses_pb';

/**
 * Describes the file realtime_event/realtime_event_responses.proto.
 */
export const file_realtime_event_realtime_event_responses: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Ci1yZWFsdGltZV9ldmVudC9yZWFsdGltZV9ldmVudF9yZXNwb25zZXMucHJvdG8SFGNvbS5nZW0uYmZmLmNvbnRyYWN0ImMKH1JlYWx0aW1lRXZlbnRzU3Vic2NyaWJlUmVzcG9uc2USOAoHc3VjY2VzcxgBIAEoCzIlLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkJvb2xlYW5SZXNwb25zZUgAQgYKBHR5cGUibQopUmVhbHRpbWVTdWJzY3JpYmVPbk1lc3NhZ2VzVXBkYXRlUmVzcG9uc2USOAoHc3VjY2VzcxgBIAEoCzIlLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkJvb2xlYW5SZXNwb25zZUgAQgYKBHR5cGUiXQoZVXNlclR5cGluZ01lc3NhZ2VSZXNwb25zZRI4CgdzdWNjZXNzGAEgASgLMiUuY29tLmdlbS5iZmYuY29udHJhY3QuQm9vbGVhblJlc3BvbnNlSABCBgoEdHlwZUIYChRjb20uZ2VtLmJmZi5jb250cmFjdFABYgZwcm90bzM',
    [file_common_common_responses]
  );

/**
 * @generated from message com.gem.bff.contract.RealtimeEventsSubscribeResponse
 */
export type RealtimeEventsSubscribeResponse =
  Message<'com.gem.bff.contract.RealtimeEventsSubscribeResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.RealtimeEventsSubscribeResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.RealtimeEventsSubscribeResponse.
 * Use `create(RealtimeEventsSubscribeResponseSchema)` to create a new message.
 */
export const RealtimeEventsSubscribeResponseSchema: GenMessage<RealtimeEventsSubscribeResponse> =
  /*@__PURE__*/
  messageDesc(file_realtime_event_realtime_event_responses, 0);

/**
 * @generated from message com.gem.bff.contract.RealtimeSubscribeOnMessagesUpdateResponse
 */
export type RealtimeSubscribeOnMessagesUpdateResponse =
  Message<'com.gem.bff.contract.RealtimeSubscribeOnMessagesUpdateResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.RealtimeSubscribeOnMessagesUpdateResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.RealtimeSubscribeOnMessagesUpdateResponse.
 * Use `create(RealtimeSubscribeOnMessagesUpdateResponseSchema)` to create a new message.
 */
export const RealtimeSubscribeOnMessagesUpdateResponseSchema: GenMessage<RealtimeSubscribeOnMessagesUpdateResponse> =
  /*@__PURE__*/
  messageDesc(file_realtime_event_realtime_event_responses, 1);

/**
 * @generated from message com.gem.bff.contract.UserTypingMessageResponse
 */
export type UserTypingMessageResponse =
  Message<'com.gem.bff.contract.UserTypingMessageResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.UserTypingMessageResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.UserTypingMessageResponse.
 * Use `create(UserTypingMessageResponseSchema)` to create a new message.
 */
export const UserTypingMessageResponseSchema: GenMessage<UserTypingMessageResponse> =
  /*@__PURE__*/
  messageDesc(file_realtime_event_realtime_event_responses, 2);
